var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageMasterBronze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "48px",
    viewBox: "0 0 45 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "rewards/page-master-bronze") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 45 0 45 47.9999652 0 47.9999652"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0 45 0 45 44.5217043 0 44.5217043"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0 0 45 0 45 44.5217043 0 44.5217043"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Product",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-Rewards-1440",
    transform: "translate(-480.000000, -585.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rewards/page-master-bronze",
    transform: "translate(480.000000, 585.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5,47.9999652 L22.5,47.9999652 C10.0736719,47.9999652 0,38.0333565 0,25.7390957 L0,4.17387826 C0,1.86883478 1.88894531,-3.47826087e-05 4.21875,-3.47826087e-05 L40.78125,-3.47826087e-05 C43.1110547,-3.47826087e-05 45,1.86883478 45,4.17387826 L45,25.7390957 C45,38.0333565 34.9263281,47.9999652 22.5,47.9999652",
    id: "Fill-1",
    fill: "#AF825D",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5,44.5217043 L22.5,44.5217043 C10.0736719,44.5217043 0,34.5550957 0,22.2608348 L0,4.17387826 C0,1.86883478 1.88894531,-3.47826087e-05 4.21875,-3.47826087e-05 L40.78125,-3.47826087e-05 C43.1110547,-3.47826087e-05 45,1.86883478 45,4.17387826 L45,22.2608348 C45,34.5550957 34.9263281,44.5217043 22.5,44.5217043",
    id: "Fill-4",
    fill: "#E5B389",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.78125,-3.47826087e-05 L4.21875,-3.47826087e-05 C1.88894531,-3.47826087e-05 0,1.86883478 0,4.17387826 L0,22.2608348 C0,34.5550957 10.0736719,44.5217043 22.5,44.5217043 C34.9263281,44.5217043 45,34.5550957 45,22.2608348 L45,4.17387826 C45,1.86883478 43.1110547,-3.47826087e-05 40.78125,-3.47826087e-05 M40.78125,4.17387826 L40.78125,22.2608348 C40.78125,32.2340522 32.5803516,40.3477913 22.5,40.3477913 C12.4196484,40.3477913 4.21875,32.2340522 4.21875,22.2608348 L4.21875,4.17387826 L40.78125,4.17387826",
    id: "Fill-7",
    fill: "#CF9C6D",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.0108437,12.452487 L33.4446328,12.452487 L11.3376797,12.452487 L9.9894375,12.452487 C9.25010156,12.452487 8.65103906,13.0455304 8.65103906,13.7766609 L8.65103906,28.4904 C8.65103906,29.2215304 9.25010156,29.8145739 9.9894375,29.8145739 L19.5698672,29.8145739 C19.5698672,30.7891826 20.3682656,31.5794435 21.3536953,31.5794435 L23.6465859,31.5794435 C24.6320156,31.5794435 25.4304141,30.7891826 25.4304141,29.8145739 L35.0108437,29.8145739 C35.7501797,29.8145739 36.3492422,29.2215304 36.3492422,28.4904 L36.3492422,13.7766609 C36.3492422,13.0455304 35.7501797,12.452487 35.0108437,12.452487",
    id: "Fill-10",
    fill: "#AF825D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2320781,27.409287 L25.4305547,27.409287 C24.0650859,27.409287 22.9175859,28.2778087 22.5923906,29.4538087 L22.4074687,29.4538087 C22.082625,28.2778087 20.9354766,27.409287 19.5696563,27.409287 L11.7674297,27.409287 C11.3659453,27.409287 11.0393438,27.0868522 11.0393438,26.6889391 L11.0393438,10.2312 C11.0393438,9.83398261 11.3659453,9.51085217 11.7674297,9.51085217 L19.5696563,9.51085217 C21.1875469,9.51085217 22.4999297,10.7313739 22.4999297,12.2367652 C22.4999297,10.7313739 23.8116094,9.51085217 25.4305547,9.51085217 L33.2320781,9.51085217 C33.6342656,9.51085217 33.9601641,9.83328696 33.9601641,10.2312 L33.9601641,26.6889391 C33.9601641,27.0868522 33.6342656,27.409287 33.2320781,27.409287",
    id: "Fill-12",
    fill: "#F3F7FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.5,
    y1: 12.0253565,
    x2: 22.5,
    y2: 28.7154435,
    id: "Stroke-14",
    stroke: "#E2E9F2",
    strokeWidth: 1.73913043,
    strokeLinecap: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageMasterBronze);
export default __webpack_public_path__ + "static/media/page-master-bronze.70bd064ed43a3cd58bf4faac13742d3c.svg";
export { ForwardRef as ReactComponent };